// import { Avatar } from '@mui/material'
// import ModalBox from '../modal/ModalBox'
// import { charLimit } from '../../utils/charLimit'

// const ImagePreviewModel = ({ show, close, imageUrl, title }) => {
//   return (
//     <ModalBox
//       status={show}
//       onClose={close}
//       title={charLimit(title, 32)}
//       closeIcon
//       size={'sm'}
//       custom
//       customizedFooter={
//         <button className="btn_size" onClick={close}>
//           Close
//         </button>
//       }
//     >
//       <div className="mt-3">
//         <Avatar
//           variant="square"
//           sx={{
//             width: '100%',
//             borderRadius: 1,
//             height: 300,
//             border: '1px solid #FF8989',
//           }}
//           src={imageUrl}
//           className="image-preview"
//         />
//       </div>
//     </ModalBox>
//   )
// }
// export default ImagePreviewModel

import { Avatar } from '@mui/material';
import ModalBox from '../modal/ModalBox';
import { charLimit } from '../../utils/charLimit';

const ImagePreviewModel = ({ show, close, imageUrl, title, mediaArray }) => {
  // If mediaArray is provided, use it; otherwise fall back to single imageUrl
  const mediaItems = mediaArray || (imageUrl ? [{ url: imageUrl, type: imageUrl.endsWith(".mp4") ? "video" : "image" }] : []);

  return (
    <ModalBox
      status={show}
      onClose={close}
      title={charLimit(title, 32)}
      closeIcon
      size={'lg'}
      custom
      customizedFooter={
        <button className="btn_size" onClick={close}>
          Close
        </button>
      }
    >
      <div className="mt-3">
        {mediaItems.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {mediaItems.map((mediaItem, index) => {
              const isVideo = mediaItem.type === "video" || mediaItem.url.endsWith(".mp4");
              
              return (
                <div key={index} style={{ textAlign: 'center' }}>
                  {isVideo ? (
                    <video 
                      width="100%" 
                      controls
                      style={{ maxHeight: '400px', borderRadius: '8px' }}
                    >
                      <source src={mediaItem.url} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <Avatar
                      variant="square"
                      sx={{
                        width: '100%',
                        borderRadius: 1,
                        height: 400,
                        border: '1px solid #FF8989',
                        objectFit: 'contain'
                      }}
                      src={mediaItem.url}
                      className="image-preview"
                    />
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <p>No media available</p>
          </div>
        )}
      </div>
    </ModalBox>
  );
};

export default ImagePreviewModel;
